import { Component, Input, OnInit } from "@angular/core";
import { Formatter } from '../../services/formatter';
import { PlanDetailsService } from '../../services/planDetails.service';
import { SessionHandlerService } from "../../services/sessionHandler.service";

@Component({
  selector: 'app-plan-card-mapping',
  templateUrl: './planCardMapping.template.html',
  styleUrls: ['./planCardMapping.style.scss']
})
export class PlanCardMappingComponent implements OnInit {

  @Input() content;
  @Input() imageURL;
  @Input() contentHeader;



  isPartnerLogoLoaded: boolean;

  constructor(
    public formatter: Formatter,
  ) { }

  ngOnInit() {
  }

  public isLogoLoaded(color, id) {
    console.log(color, id);
    const elem: any = document.getElementsByClassName('card-object-header1');
    console.log(elem);
    console.log(elem[id].children);
    for (let i = 0; i < elem[id].children.length; i++) {
      elem[id].children[i].style.setProperty('background-color', color);
      const childArray = elem[id].children[i].querySelectorAll('*');
      for (let j = 0; j < childArray.length; j++) {
        if (childArray[j].className !== 'partner-logo') {
          childArray[j].style.setProperty('background-color', color);
        }
      }
    }
    elem[id].style.setProperty('background-color', color);
    this.isPartnerLogoLoaded = true;
  }




}